import { Container } from 'react-bootstrap'
import styles from './style.module.scss'
import PropTypes from 'prop-types'

const NavSlider = ({ activeItem, items, onItemClick, itemFormatter, isActive, styling, className, containerClassName, homeLayout }) => {
  return (
    <div className={`${styles.scorecardNav} ${styling} ${className}`}>
        <Container className={`text-nowrap scroll-list d-flex m-auto align-items-center !mb-0 ${!homeLayout && 'px-0'} ${containerClassName || ''}`}>
            {items.map((item, index) => (
                    <button
                    key={index}
                    className={`${(isActive ? isActive(item, index) : activeItem === item) ? styles.active : ''}`}
                    onClick={() => onItemClick(item)}
                    >
                            {itemFormatter ? itemFormatter(item, index) : item}
                    </button>
            ))}
            </Container>
    </div>
  )
}
NavSlider.propTypes = {
  activeItem: PropTypes.any,
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  onItemClick: PropTypes.func.isRequired,
  itemFormatter: PropTypes.func,
  styling: PropTypes.any,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  homeLayout: PropTypes.bool,
  isActive: PropTypes.func
}

export default NavSlider
